module.exports = __webpack_public_path__ + "media/img/pages/companies/sko-8a3111fd9aeccb44985d37d9a641f072.png";